export enum LanguageEnum {
  DA = 'da', NO = 'no', SV = 'sv', FI = 'fi', EN = 'en'
}
